import {http} from 'src/services/http'
import {RatingType, ReviewType} from 'src/types/review'

export async function publicGetPropertyReviewsApi(
  propertyId: number,
  page = 1,
  limit = 20,
) {
  const {data} = await http.get(`/public/property/${propertyId}/reviews`, {
    params: {
      page,
      limit,
    },
  })

  return data
}

export async function getPropertyReviewsApi(
  propertyId: number,
  page = 1,
  limit = 20,
) {
  const {data} = await http.get(`/property/${propertyId}/reviews`, {
    params: {
      page,
      limit,
    },
  })

  return data
}

export async function sendHostReviewApi(
  bookingId: number,
  ratings: Partial<RatingType>,
  publicComment: string | null,
  privateComment: string | null,
) {
  const {data} = await http.post(`/booking/${bookingId}/host_review`, {
    ratings,
    public_comment: publicComment,
    private_comment: privateComment,
  })

  return data
}

export async function getHostReviewApi(bookingId: number) {
  const {data} = await http.get(`/booking/${bookingId}/host_review`)

  return data
}

export async function sendGuestReviewApi(
  bookingId: number,
  ratings: Partial<RatingType>,
  publicComment: string | null,
  privateComment: string | null,
) {
  const {data} = await http.post(`/booking/${bookingId}/guest_review`, {
    ratings,
    public_comment: publicComment,
    private_comment: privateComment,
  })

  return data
}

export async function getGuestReviewApi(bookingId: number) {
  const {data} = await http.get(`/booking/${bookingId}/guest_review`)

  return data
}

export async function adminToggleReviewVisibilityApi(reviewId: number) {
  const {data} = await http.put(`/admin/host_review/${reviewId}/visible`)

  return data
}

export async function adminGetAllHostReviewsApi(
  page: number,
  search: string | null,
  color: string,
) {
  const {data} = await http.get(`/admin/all_host_reviews`, {
    params: {
      page,
      search,
      color: color === 'all' ? '' : color,
    },
  })

  return data
}

export async function adminGetAllGuestReviewsApi(
  page: number,
  search: string | null,
  color: string,
) {
  const {data} = await http.get(`/admin/all_guest_reviews`, {
    params: {
      page,
      search,
      color: color === 'all' ? '' : color,
    },
  })

  return data
}

export async function adminUpdateHostReviewColorApi(review: ReviewType) {
  const {data} = await http.put(`/admin/host_review/${review.id}/color`)

  return data
}

export async function adminUpdateGuestReviewColorApi(review: ReviewType) {
  const {data} = await http.put(`/admin/guest_review/${review.id}/color`)

  return data
}

export async function adminUpdateHostReviewApi(review: ReviewType) {
  const {data} = await http.put(`/admin/host_review/${review.id}`, review)

  return data
}

export async function adminUpdateGuestReviewApi(review: ReviewType) {
  const {data} = await http.put(`/admin/guest_review/${review.id}`, review)

  return data
}
